<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-relation
      code="organisation"
      v-model="sasReconnaissanceDeFormation.organisation"
      :live="liveSasReconnaissanceFormation('10700_300')"
      :list="organisations"
    ></opq-relation>

    <opq-text-field
      code="titre-formation"
      v-model="sasReconnaissanceDeFormation.titreDeLActivite"
      :live="liveSasReconnaissanceFormation(10702)"
      width="700"
      disabled
      :longueurMax="200"
    ></opq-text-field>

    <opq-date-picker
      code="debut-reconnaissance"
      v-model="sasReconnaissanceDeFormation.debutDeLaReconnaissance"
      :live="liveSasReconnaissanceFormation(10703)"
      :minYear="2012"
      :maxYear="new Date().getFullYear() + 2"
      :condition="
        (v) => {
          let greaterThanJune2012 = new Date(v) >= new Date(2012, 5, 0)
          let lessThan6Months = new Date(v) <= new Date(new Date().setMonth(new Date().getMonth() + 6))
          return greaterThanJune2012 && lessThan6Months
        }
      "
      conditionMessage="La date de début doit être après juin 2012 et dans moins de 6 mois."
      disabled
    ></opq-date-picker>

    <opq-text-field
      code="ancien-numero"
      v-model="sasReconnaissanceDeFormation.ancienNumeroDeReconnaissance"
      :live="liveSasReconnaissanceFormation(10704)"
      is-numero-reconnaissance
      disabled
    ></opq-text-field>

    <opq-catalogue
      code="categorie-activite"
      v-model="sasReconnaissanceDeFormation.categorieDActivite"
      :live="liveSasReconnaissanceFormation(10705)"
    ></opq-catalogue>

    <opq-catalogue
      code="type-activite"
      v-model="sasReconnaissanceDeFormation.typeDActivite"
      :live="liveSasReconnaissanceFormation(10706)"
      @eudo-updated="updatePanier"
    ></opq-catalogue>

    <opq-text-field
      :opq-if="estEvenement"
      code="nombre-jours-evenement"
      v-model="sasReconnaissanceDeFormation.nbJoursEvenement"
      :live="liveSasReconnaissanceFormation(10743)"
      @eudo-updated="updatePanier"
      is-number
    ></opq-text-field>

    <opq-catalogue
      :opq-if="estEvenement"
      code="comite-scientifique"
      v-model="sasReconnaissanceDeFormation.ateliersApprouvesParUnComiteScientifique"
      :live="liveSasReconnaissanceFormation(10707)"
    ></opq-catalogue>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import { mapActions } from "vuex"
export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasReconnaissanceDeFormation() {
      return this.sas.sasReconnaissanceDeFormation
    },

    organisations() {
      return this.sasReconnaissanceDeFormation.listOrganisations
    },

    estEvenement() {
      return this.getCatalogueCodeById(9811, this.sasReconnaissanceDeFormation.typeDActivite) == "2"
    }
  },

  methods: {
    ...mapActions(["fetchPanier"]),
    liveSasReconnaissanceFormation(cle) {
      return { endpoint: "/sas-reconnaissance-formation/", cle: cle, fileId: this.sasReconnaissanceDeFormation.id }
    },
    async updatePanier() {
      await this.fetchPanier(this.sas.id)
    }
  }
}
</script>

<style>
</style>